// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"8f5dd39e","843":"5457d730"}[chunkId] + ".chunk.css";
};